import { render, staticRenderFns } from "./CCExoticSelector.vue?vue&type=template&id=56420589&"
import script from "./CCExoticSelector.vue?vue&type=script&lang=ts&"
export * from "./CCExoticSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports